import { doc, getDoc, where } from "firebase/firestore";
import { db } from "../../../firebase";

const GetSingleHolidays = async (HolidaysID) => {
  try {
    const HolidayDocument = doc(db, "Holidays", HolidaysID);
    const HolidaysSnapshot = await getDoc(
      HolidayDocument,
      where("IsDeleted", "==", false)
    );

    let Holiday = { ...HolidaysSnapshot.data(), id: HolidaysSnapshot.id };

    return Holiday;
  } catch (error) {
    console.log(error);
  }
};

export default GetSingleHolidays;
